import { ApprovalPolicy, DepartmentApprovalPolicy } from '../../models/approval/approval-policy.model';

export interface IApprovalState {
    policies: ApprovalPolicy[];
    departmentPolicies: DepartmentApprovalPolicy[];
    loading: boolean;
    error: string | null;
}

export const initialApprovalState: IApprovalState = {
    policies: [],
    departmentPolicies: [],
    loading: false,
    error: null,
};
